import {Form as AntForm} from 'antd';
import React, {useEffect} from 'react';

import Form from '../../../../../../components/Form/Form';
import MobileModalForm from '../../../../../../components/Form/MobileModalForm';
import * as formInputNames from '../../../../../../consts/form/formInputNames';
import * as localizationKeys from '../../../../../../consts/localization/localizationKeys';
import useIsMobileViewport from '../../../../../../hooks/useIsMobileViewport';
import deviceProfilesService from '../../../../../../services/deviceProfiles/deviceProfilesService';
import {getLocalizedStrings} from '../../../../../../services/localization/localizationService';
import log from '../../../../../../services/logger/log';
import {setCurrentModel} from '../../../../../../state/ducks/device';
import {cleanDeviceProfiles} from '../../../../../../state/ducks/deviceProfiles';
import {dispatch} from '../../../../../../state/store';
import helpers from '../../../../../../utils/helpers';
import deviceModelModalService from './deviceModelModalService';

const DeviceModelModal = (props) => {
    const {onOk, onCancel, modalType, modelId} = props || {};

    const [form] = AntForm.useForm();
    const isMobile = useIsMobileViewport();
    const strings = getLocalizedStrings();

    const modalData = deviceModelModalService.getDeviceModelModalContent(modalType);

    const {formContent, title, submitButton, cancelButton, initialValues} = modalData || {};

    const onFinish = async () => {
        try {
            const values = await form.validateFields();

            if (isMobile) {
                const profile = values[formInputNames.CHIRPSTACK_PROFILE_ID];

                if (profile && typeof profile === 'object') {
                    values[formInputNames.CHIRPSTACK_PROFILE_ID] = profile.key ?? profile.value;
                }
            }
            values.deviceModelID = modelId;

            helpers.runFunction(onOk, values);
        } catch (error) {
            log.error(`DeviceModelModal - validate failed: ${error}`);
        }
    };

    const setFormField = (name, value) => form.setFieldsValue({[name]: value});

    const handleSelect = (value, name, option) => {
        const currentValue = form.getFieldValue(name);

        if (currentValue?.value === option.value) return;

        setFormField(name, option.key);

        if (name === formInputNames.CHIRPSTACK_PROFILE_ID && option?.description) {
            const currentDescription = form.getFieldValue(formInputNames.DEVICE_MODEL_DESCRIPTION) || '';

            if (!currentDescription.includes(option.description)) {
                const newDescription = currentDescription.trim()
                    ? `${currentDescription} - ${option.description}`
                    : option.description;

                form.setFieldsValue({
                    [formInputNames.DEVICE_MODEL_DESCRIPTION]: newDescription,
                });
            }
        }
    };

    useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }

        deviceProfilesService.getDeviceProfilesList();

        return () => {
            dispatch(setCurrentModel(null));
            dispatch(cleanDeviceProfiles());
            form.resetFields();
        };
    }, []);

    const handleChange = () => {};

    if (isMobile)
        return (
            <MobileModalForm
                form={form}
                formName='settings-devicegroupmodelsmodal'
                title={title}
                closeLabel={strings[localizationKeys.SETTINGS_MOBILE_CLOSE_FORM]}
                onCancel={onCancel}
                onFinish={onFinish}
                formFields={formContent}
                submitButton={submitButton}
                cancelButton={cancelButton}
                initialValues={initialValues}
                handleChange={handleChange}
                handleSelect={handleSelect}
            />
        );

    return (
        <Form
            handleSelect={handleSelect}
            closeModal={onCancel}
            submitButton={submitButton}
            onFinish={onFinish}
            title={title}
            formFields={formContent}
            cancelButton={cancelButton}
            formInstance={form}
            initialValues={initialValues}
            handleChange={handleChange}
        />
    );
};

export default DeviceModelModal;
